import { TestDefinition, QuestionType } from '../../types';

export const TESTS_FUNCIONALIDAD: TestDefinition[] = [
  {
    id: 'gaf',
    code: 'GAF',
    name: 'Global Assessment of Functioning',
    category: 'Funcionalidad',
    description: 'Escala de evaluación global del funcionamiento (0-100). Considera funcionamiento psicológico, social y ocupacional. Parte del DSM-IV. Puntuación única con descriptores detallados para cada rango.',
    questions: [
      {
        id: 'gaf_score',
        text: 'Seleccione el nivel de funcionamiento global del paciente',
        type: QuestionType.LIKERT,
        options: [
          { label: '91-100: Funcionamiento superior en amplia gama de actividades', value: 95 },
          { label: '81-90: Síntomas ausentes o mínimos, buen funcionamiento', value: 85 },
          { label: '71-80: Síntomas leves y transitorios', value: 75 },
          { label: '61-70: Algunos síntomas leves o dificultad moderada', value: 65 },
          { label: '51-60: Síntomas moderados o dificultad moderada en funcionamiento', value: 55 },
          { label: '41-50: Síntomas serios o deterioro serio en funcionamiento', value: 45 },
          { label: '31-40: Deterioro en prueba de realidad o comunicación, o deterioro importante', value: 35 },
          { label: '21-30: Conducta influenciada por delirios/alucinaciones o deterioro grave', value: 25 },
          { label: '11-20: Peligro de lesionarse o incapacidad para mínima higiene', value: 15 },
          { label: '1-10: Peligro persistente de lesionar gravemente a otros o a sí mismo', value: 5 }
        ]
      }
    ],
    interpretations: [
      { min: 91, max: 100, label: 'Funcionamiento Superior', color: 'bg-green-100 text-green-800' },
      { min: 81, max: 90, label: 'Funcionamiento Bueno', color: 'bg-green-50 text-green-700' },
      { min: 71, max: 80, label: 'Funcionamiento Adecuado', color: 'bg-yellow-50 text-yellow-700' },
      { min: 61, max: 70, label: 'Dificultad Leve-Moderada', color: 'bg-yellow-100 text-yellow-800' },
      { min: 51, max: 60, label: 'Dificultad Moderada', color: 'bg-orange-100 text-orange-800' },
      { min: 41, max: 50, label: 'Dificultad Seria', color: 'bg-orange-200 text-orange-900' },
      { min: 31, max: 40, label: 'Deterioro Mayor', color: 'bg-red-100 text-red-800' },
      { min: 21, max: 30, label: 'Deterioro Grave', color: 'bg-red-200 text-red-900' },
      { min: 11, max: 20, label: 'Deterioro Muy Grave', color: 'bg-red-300 text-red-950' },
      { min: 1, max: 10, label: 'Peligro Persistente', color: 'bg-red-400 text-white' }
    ]
  }
];
